import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    draggableListContainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      gap: 8,
    },
    draggableItemContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      padding: 10,
      borderRadius: 8,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
    },
    dragHandleIcon: {
      cursor: 'grab',
    },
    chosenItem: {
      opacity: 1,
    },
    ghostItem: {
      opacity: 0,
    },
  });

export default styles;
